import React from 'react';
import {get} from 'lodash';
import moment from 'moment';
import axios from 'axios';
import Waypoint from 'react-waypoint';

import {
  metaLoading,
} from '../lib/helpers';

import Loading from './Loading';

class PaymentLogs extends React.Component {
  state = {
    ...metaLoading,
    shouldFetch: true,
    logs: []
  }

  fetchData = () => {
    if (this.state.shouldFetch) {
      axios.get(`/${gon.currentProvider}/api/users/${get(this.props, 'userId')}/payment_logs`)
      .then((res) => {
        if (res.status == 200 && get(res, 'data')) {
          this.setState({
            logs: res.data['logs'],
            shouldFetch: false,
            meta: {
              isLoading: false
            },
          })
        }
      })
    }
  }

  componentDidMount() {
    this.setState({
      meta: {
        isLoading: true,
      },
    })
  }

  render() {
    return (
      <React.Fragment>
        <div className='User__header'>
          <h3 className='User__header__h3'>Lastest 15 payment logs</h3>
        </div>

        <Waypoint onEnter={this.fetchData}>
          <div className='Table Table--payment-logs'>
            <div className='Table__row'>
              <div className='Table__col Table__col--th'>Date</div>
              <div className='Table__col Table__col--th'>Transaction ID</div>
              <div className='Table__col Table__col--th'>Item</div>
              <div className='Table__col Table__col--th'>Description</div>
              <div className='Table__col Table__col--th'>Amount</div>
            </div>

            <Loading
              isLoading={get(this.state, 'meta.isLoading') && get(this.state, 'logs.length', 0) == 0}
            >
              {get(this.state, 'logs', []).map((log) => (
                <div key={log.id} className='Table__row'>
                  <div className='Table__col'>{moment(log.createdAt).format('YYYY-MM-DD HH:mm')}</div>
                  <div className='Table__col'>{log.transactionId}</div>
                  <div className='Table__col'>{log.sku}</div>
                  <div className='Table__col'>{log.description}</div>
                  <div className='Table__col'>{log.amount}</div>
                </div>
              ))}
            </Loading>
          </div>
        </Waypoint>
      </React.Fragment>
    );
  }
}

export default PaymentLogs
